// extracted by mini-css-extract-plugin
export default {"table":"ObjectTab_table__vNsuh","emptyTextBlock":"ObjectTab_emptyTextBlock__LbWUE"};